import React from 'react';
import { makeStyles } from '@material-ui/core';
import WealthCreateGuesser from '../../base/components/guesser/wealth-create.guesser';
import { useAuthUser, useQueryParams } from '../../base/hooks';
import BrandForm from './components/BrandForm';
import { useTransformBrandData } from './components/utils';

const BrandCreate = (props) => {
  const classes = useStyles();
  const { groupId } = useQueryParams();
  const user = useAuthUser();
  const transformBrandData = useTransformBrandData();

  return (
    <WealthCreateGuesser
      {...props}
      transform={transformBrandData}
      custom
      className={classes.wrapper}
      initialValues={() =>
        groupId || user.group?.id
          ? {
              group: {
                id: groupId || user.group.id,
              },
            }
          : {}
      }
    >
      <BrandForm />
    </WealthCreateGuesser>
  );
};

export default BrandCreate;

const useStyles = makeStyles({
  wrapper: {
    maxWidth: '960px',
    width: '100%',
    margin: 'auto',
  },
});
